import React, {useEffect, useRef, useState} from "react";
import moment from "moment";
import {useIntl} from "react-intl";
import {IconAlertSquareRoundedFilled} from "@tabler/icons-react";
import {classNames} from "@ct-react/core";
import "./cart-item-countdown.scss";

type CartItemCountdownProps = {
  expirationDate: moment.Moment;
  onRefresh?: () => void;
}

const CartItemCountdown = (
  {
    expirationDate,
    onRefresh = () => void 0
  }: CartItemCountdownProps) => {

  const intl = useIntl();

  const [ duration, setDuration ] = useState(moment.duration(expirationDate.diff(moment.utc(), "s"), "s"));
  const intervalRef = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

  useEffect(() => {
    intervalRef.current = setInterval(() =>
      setDuration(prev => prev.subtract(1, "s").clone()), 1000);
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (duration.asSeconds() === 0)
      clearInterval(intervalRef.current);
  }, [ duration ]);

  const wrapperClasses = classNames("cart-item-countdown", { expired: duration.asSeconds() === 0 });

  if (duration.asSeconds() === 0)
    return (
      <div className={wrapperClasses}>
        <IconAlertSquareRoundedFilled />
        {intl.formatMessage({
          id: "cart-item-end-lifetime",
          defaultMessage: "La disponibilité a été libérée"
        })}
        <span className="refresh" onClick={onRefresh}>
          {intl.formatMessage({ id: "generics-refresh", defaultMessage: "Rafraîchir" })}
        </span>
      </div>);

  return (
    <div className={wrapperClasses}>
      <IconAlertSquareRoundedFilled />
      <span>
        {intl.formatMessage({
          id: "cart-item-lifetime",
          defaultMessage: "La disponibilité sera automatiquement libérée dans {val}"
        }, { val: <time dateTime={duration.toISOString()}>{moment(duration.asMilliseconds()).format("mm:ss")}</time> })}
      </span>
    </div>);

}

export default CartItemCountdown;
